module.exports = __webpack_public_path__ + "img/esg.476c4e6c.svg";